var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"page-body",attrs:{"aria-label":"Content"}},[_c('h1',{staticClass:"sr-only"},[_vm._v(_vm._s(_vm.currentRouteContent.title))]),_c('router-view',{attrs:{"content-data":_vm.currentRouteContent}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }